import { createController, prepActions } from "~/hocs/crud";
import { service } from "./service";
import { resetPasswordSaga } from "./sagas";

const actions = prepActions(service);
const userSagas = createController(service, actions);

export { resetPasswordSaga, userSagas, actions };
